import axiosApi from '@apis/axiosApi'
import { handleError } from '@utils/commonUtils'
import * as queryString from 'query-string'

const BASE = '/tuyen-dung/lich-phong-van'
const UV = '/tuyen-dung/ung-vien'

// Lọc danh sách lịch phỏng vấn
export function locLichPhongVan(querySt?: string) {
  try {
    const query = querySt ? queryString.parse(querySt) : {}
    return axiosApi.get(`${BASE}/loc-danh-sach`, { params: query || {} })
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Lấy danh sách lịch phỏng vấn theo ứng viên
export function layDanhSachLichPhongVanTheoUngVien(candidateId: number) {
  try {
    return axiosApi.get(`${UV}/${candidateId}/lich-phong-van`)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Lấy chi tiết lịch phỏng vấn
export function layChiTietLichPhongVan(id: number) {
  try {
    return axiosApi.get(`${BASE}/${id}/chi-tiet`)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Tạo lịch phỏng vấn
export function taoLichPhongVan(params: any) {
  try {
    return axiosApi.post(`${BASE}/tao`, params)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Cập nhật lịch phỏng vấn
export function capNhatLichPhongVan(id: number, params: any) {
  try {
    return axiosApi.put(`${BASE}/${id}/cap-nhat`, params)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Xóa lịch phỏng vấn
export function xoaLichPhongVan(id: number) {
  try {
    return axiosApi.delete(`${BASE}/${id}/xoa`)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}
